import React from "react";
import { useApp } from "../App";

function KeptiIcon({ size = 56 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none">
      <rect width="56" height="56" rx="14" fill="#1a2744"/>
      <rect x="13" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="30" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="13" y="30" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="30" y="30" width="13" height="13" rx="2" fill="#c0392b"/>
    </svg>
  );
}

export { KeptiIcon };

export default function Login({ onSignIn }) {
  const { t, toggleLang } = useApp();

  return (
    <div className="login-page">
      <KeptiIcon size={80} />
      <h1 className="login-brand">kepti</h1>
      <p className="login-tagline-main">Pass it on.</p>
      <p className="login-school">Cascais · Portugal</p>

      <button className="google-btn" onClick={onSignIn}>
        <svg width="20" height="20" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.7 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.7-8 19.7-20 0-1.3-.1-2.7-.1-4z"/>
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.1 18.9 12 24 12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4c-7.7 0-14.4 4.4-17.7 10.7z"/>
          <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5l-6.2-5.2C29.3 35.3 26.8 36 24 36c-5.3 0-9.7-2.9-11.3-7.1L6 34c3.3 6.3 10 10 18 10z"/>
          <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.9 2.4-2.5 4.4-4.5 5.8l6.2 5.2c3.7-3.4 5.9-8.4 5.9-14 0-1.3-.1-2.7-.1-4z"/>
        </svg>
        {t.signIn}
      </button>

      <p className="login-school">The WhatsApp group, evolved.<br/>Made with love by a KCS parent.</p>
      <p className="login-note">{t.inviteOnly}</p>
      <button onClick={toggleLang} className="lang-btn">{t.language}</button>
    </div>
  );
}
